import React from "react";
import { FaCcVisa, FaCcMastercard, FaCcAmex } from "react-icons/fa";
import { Box, Grid, Typography } from "@mui/material";

const getCardIcon = (brand: string, size: number): JSX.Element | null => {
  switch (brand.toLowerCase()) {
    case "visa":
      return <FaCcVisa size={size} />;
    case "mastercard":
      return <FaCcMastercard size={size} />;
    case "amex":
    case "american express":
      return <FaCcAmex size={size} />;
    default:
      return null;
  }
};

const CardBrandDisplay = ({
  cardBrand,
  size,
}: {
  cardBrand: string;
  size: number;
}) => {
  return (
    <Box sx={{ border: "1px solid", borderRadius: 2, padding: 1 }}>
      <Grid container alignItems="center" spacing={2} direction={"row"}>
        <Grid item xs={4}>
          {getCardIcon(cardBrand, size)}
        </Grid>
        <Grid item xs={8}>
          <Typography fontSize={12}>{cardBrand}</Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

export default CardBrandDisplay;
